/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Misfit_3Inputs */

const en_pc_alt_misfit_3 = /** @type {(inputs: Pc_Alt_Misfit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR for scanned pages in scripts other than Latin.`)
};

const zh_pc_alt_misfit_3 = /** @type {(inputs: Pc_Alt_Misfit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对拉丁字母以外文字的扫描页进行 OCR。`)
};

/**
* | output |
* | --- |
* | "OCR for scanned pages in scripts other than Latin." |
*
* @param {Pc_Alt_Misfit_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_misfit_3 = /** @type {((inputs?: Pc_Alt_Misfit_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Misfit_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_misfit_3(inputs)
	return zh_pc_alt_misfit_3(inputs)
});
export { pc_alt_misfit_3 as "pc.alt.misfit.3" }